import React from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import Button from "../lib_react_adminlte/componentes/Button.jsx";
import InputGroup from "../lib_react_adminlte/componentes/InputGroup.jsx";
import { Table } from "../lib_react_adminlte/componentes/Table.jsx";
import Api from "../utils/Api.jsx";
import GenericUtils from "../lib_react_frontend/utils/GenericUtils";
import Tabs from "../lib_react_adminlte/template/tab/Tabs.jsx";
import TabHeader from "../lib_react_adminlte/template/tab/TabHeader.jsx";
import TabsHeader from "../lib_react_adminlte/template/tab/TabsHeader.jsx";
import TabsContent from "../lib_react_adminlte/template/tab/TabsContent.jsx";
import TabContent from "../lib_react_adminlte/template/tab/TabContent.jsx";
import ContentWrapper from "../lib_react_adminlte/componentes/ContentWrapper.jsx";
import {
  selectTab,
  showTabs,
} from "../lib_react_adminlte/template/tab/tabActions";
import constants from "../utils/constants";

/**
 * Cadastro padrão do sistema, possui 4 abas:
 * - listar
 * - incluir
 * - alterar
 * - excluir
 */
class Cadastro extends React.Component {
  state = {
    filtro: "",
    filtroAplicado: false,
    tab: { selected: "", visible: {} },

    qtderegistros: 25,
    range: {
      from: 0,
      to: 25,
    },
    registros: [],
  };

  componentWillMount() {
    this.carregarRegistros();
    this.resetarAbas();
  }

  /**
   * Chamado quando for realizado um click em um dos botões de ação da tabela.
   * @param {any} actionId o Id da coluna clicada
   * @param {object} item O Registro clicado
   */
  async onTableActionClick(actionId, item) {
    if (this.props.onTableActionClick) {
      this.props.onTableActionClick(actionId, item);
    }

    if (this.props.actionId) {
      this.props.actionId(actionId);
    }

    if (actionId === "excluir") {
      // Exclusão
      this.props.setRegistro(item);
      this.props.dispatch(showTabs("tabDelete"));
      this.props.dispatch(selectTab("tabDelete"));
      return;
    } else if (actionId === "editar") {
      // Edição
      this.props.setRegistro(item);
      {
        this.props.editConfig
          ? this.props.dispatch(showTabs("tabUpdate"))
          : this.props.dispatch(showTabs("tabUpdate"));
      }
      {
        this.props.renderFormConfiguracoes
          ? this.props.dispatch(showTabs("tabUpdate", "tabConfig"))
          : this.props.dispatch(showTabs("tabUpdate"));
      }
      this.props.dispatch(selectTab("tabUpdate"));
      // limpa a senha do editar usuario
      if (this.props.tabela == "tab_usuario") {
        this.props.limpaSenha();
      }
      return;
    } else if (actionId === "lock") {
      this.props.setLock(item);
      this.carregarRegistros();
    } else if (actionId === "eye") {
      // Edição
      this.props.setRegistro(item);
      this.props.dispatch(showTabs("tabEye"));

      this.props.dispatch(selectTab("tabEye"));
      return;
    }
  }

  onClickPaginacao(id) {
    let from = this.state.range.from;
    let to = this.state.range.to;
    if (id === "ant") {
      from -= this.state.qtderegistros;
      to -= this.state.qtderegistros;
      if (from <= 0) {
        from = 0;
        to = this.state.qtderegistros;
      }
    } else {
      from += this.state.qtderegistros;
      to += this.state.qtderegistros;
    }
    this.setState(
      {
        range: {
          from,
          to,
        },
      },
      this.carregarRegistros.bind(this)
    );
  }

  getTableActions() {
    return (this.props.tableActions || []).concat([
      {
        className: "btn-success btnMenor11",
        icone: "fa-pencil",
        id: "editar",
        title: "Editar",
        hidden: (e) => {
          if (e.dt_hr_fechamento) {
            return true;
          }
          return false;
        },
        tipo: Table.ACAO_TABELA,
      },
      {
        className: "btn-danger btnMenor11",
        icone: "fa-trash-o",
        hidden: (e) => {
          if (e.dt_hr_fechamento) {
            return true;
          }
          return false;
        },
        id: "excluir",
        title: "Excluir",
        tipo: Table.ACAO_TABELA,
      },

      this.props.btnlock
        ? {
            className: "btn-lock btnMenor11",
            icone: "fa-lock",
            hidden: (e) => {
              if (e.dt_hr_fechamento) {
                return true;
              }
              return false;
            },
            id: "lock",
            title: "lock",
            tipo: Table.ACAO_TABELA,
          }
        : "",

      this.props.btnlock
        ? {
            className: "btn-eye btnMenor11",
            icone: "fa-eye",
            hidden: (e) => {
              if (e.dt_hr_fechamento) {
                return false;
              }
              return true;
            },
            id: "eye",
            title: "eye",
            tipo: Table.ACAO_TABELA,
          }
        : "",

      this.props.btnImprimir
        ? {
            className: "btn-impressora btnMenor11",
            icone: "fa-print",
            id: "imprimir",
            title: "Imprimir",
            tipo: Table.ACAO_TABELA,
          }
        : "",
    ]);
  }
  // getTableActions() {
  //   return [
  //     {
  //       className: 'btn-success',
  //       icone: 'fa-pencil',
  //       id: 'editar',
  //       tipo: Table.ACAO_TABELA,
  //     },
  //     {
  //       className: 'btn-danger',
  //       icone: 'fa-trash-o',
  //       id: 'excluir',
  //       tipo: Table.ACAO_TABELA,
  //     },
  //   ].concat(this.props.tableActions || []);
  // }

  /**
   * Reseta as abas ao estado original, ou seja, a listagem e o incluir.
   */
  resetarAbas() {
    this.props.limparRegistro();
    if (this.props.showTabApp) {
      this.props.dispatch(showTabs("tabList", "tabAppConectados"));
    } else {
      this.props.dispatch(showTabs("tabList", "tabCreate"));
    }

    // this.props.dispatch(showTabs('tabList', 'tabCreate'));

    this.props.dispatch(selectTab("tabList"));
  }

  /**
   * Carrega os registros da tabela
   */
  async carregarRegistros() {
    if (!this.props.semElementoCarregando) {
      setTimeout(() => {
        GenericUtils.setElementoCarregando(this.table, true, "");
      }, 50);
    }

    let ret;

    if (this.props.getRegistros) {
      // Estão fazendo a pesquisa por fora
      ret = await this.props.getRegistros(this.state.filtro, this.state.range);
    } else {
      ret = await Api.buscar(this.props.tabela, this.state.filtro, "");
    }
    if (ret.dados) {
      this.setState({ registros: ret.dados });
    }
    this.setState({ filtroAplicado: this.state.filtro });
    if (!this.props.semElementoCarregando) {
      setTimeout(() => {
        GenericUtils.setElementoCarregando(this.table, false, "");
      }, 50);
    }
  }

  setarRegistro(lista) {
    this.setState({ registros: lista.dados });
  }

  carregarConfiguracoes() {
    if (this.props.getDadosConfiguracoes()) {
      this.props.getDadosConfiguracoes();
    }
  }

  carregarRotinasCondominio() {
    if (this.props.getDadosRotinasCondominio()) {
      this.props.getDadosRotinasCondominio();
    }
  }

  carregarAppConectados() {
    if (this.props.getDadosAppConectados()) {
      this.props.getDadosAppConectados();
    }
  }

  /**
   * Salva o registro no banco de dados, caso ele já exista ele é atualizado.
   * Se ele não existir ele é cadastrado.
   */
  async salvar() {
    const verificarCampoVazio = this.props.getRegistro();

    if (this.props.cadastroEstoque) {
      if (verificarCampoVazio.registro.produtoServicos.length <= 0) {
        return toastr.warning("Aviso", "Não foi possivel concluir o ajuste");
      }
    }

    const ret = await Api.salvar(
      this.props.tabela,
      this.props.pk,
      this.props.getRegistro()
    );
    if (!ret.status) {
      return toastr.error(
        "Erro!",
        ret.erro.error_message || ret.erro.sqlMessage || ret.erro
      );
    }
    if (this.props.onSalvar) {
      const ret2 = this.props.onSalvar();
      Promise.resolve(ret2).then();
    }
    this.resetarAbas();
    this.props.limparRegistro();
    this.carregarRegistros();
  }

  async salvarExibicao() {
    if (this.props.getRegistroExibicao()) {
      const exibicao = this.props.getRegistroExibicao();
      const registro = this.props.getRegistro();

      exibicao.cod_usuario = registro.cod_usuario;

      const ret = await Api.salvar(
        "tab_exibicao_usuario",
        "cod_exibicao_usuario",
        exibicao
      );

      if (registro.tipo_usuario == constants.tipo_usuario_proprietario) {
        const alteraUser = await Api.salvar(
          "tab_usuario_alterar_exibicao",
          "",
          registro
        );

        if (!alteraUser.status) {
          return toastr.error(
            "Erro!",
            alteraUser.erro.error_message || alteraUser.erro.sqlMessage
          );
        }
      }

      if (!ret.status) {
        return toastr.error(
          "Erro!",
          ret.erro.error_message || ret.erro.sqlMessage
        );
      }
    }
    if (this.props.usuario.tipo_usuario == constants.tipo_usuario_proprietario) {
      const ret = await Api.buscar(
        "dados_carregar_usuario",
        "",
        this.props.usuario.cod_usuario
      );

      this.props.dispatch({
        type: "on_login",
        usuario: ret.dados,
      });
    }
    toastr.success("Sucesso", "Operação Realizada com Sucesso");

    
  }

  /**
   * Exclui o registro no banco de dados
   */
  async excluir() {
    const ret = await Api.excluir(
      this.props.tabela,
      this.props.pk,
      this.props.getRegistro()
    );
    if (!ret.status) {
      return toastr.error("Erro!", ret.erro.error_message);
    }
    this.resetarAbas();
    this.carregarRegistros();
    this.props.limparRegistro();
  }

  limparRegistros() {
    this.setState({ registros: [] });
  }

  validaCampos() {
    if (this.visualizando) {
      return false;
    }
    const registro = this.props.getRegistro(true);
    if (this.props.camposObrigatorios) {
      for (const campo of this.props.camposObrigatorios) {
        if (registro[campo] != null) {
          if (
            registro.hasOwnProperty(campo) &&
            (registro[campo].length === 0 || registro[campo] === 0)
          ) {
            return true;
          }
        }
      }
    }

    return false;
  }

  /**
   * Renderiza a página de listagem do cadastro.
   * Deve ser mandado o prop 'renderColunas' para esse componente.
   */
  renderList() {
    return (
      <div>
        {this.props.tirarFiltroPadrao ? (
          ""
        ) : (
          <div className="d-flex flex-row">
            {/* Input de filtro: */}
            <div className="flex ml-5">
              <InputGroup
                value={this.state.filtro}
                onChange={(e) =>
                  this.setState({ filtro: e.target.value }, () => {
                    this.carregarRegistros();
                  })
                }
                placeholder="Digite seu filtro"
                buttonLabel="Filtrar!"
                buttonClassName="btn-system-color"
                onKeyEnter={this.carregarRegistros.bind(this)}
                onClick={this.carregarRegistros.bind(this)}
              />
            </div>
          </div>
        )}

        {this.props.renderFormInicial ? (
          <div className="">
            <div className="m-10">{this.props.renderFormInicial()}</div>
          </div>
        ) : (
          ""
        )}

        <div className="relative" style={{ overflow: "auto" }}>
          {/* Tabela de registros: */}
          <Table
            header="Registros"
            data={this.state.registros || []}
            ref={(e) => (this.table = e)}
            tableColor={this.props.tableColor}
            actionStyle={this.props.styleActionsTable}
            maxHeight={this.props.maxHeight}
            pagination
            onDoubleClick={
              this.props.onDoubleClick
                ? this.onTableActionClick.bind(
                    this,
                    "editar",
                    this.props.onDoubleClick
                  )
                : ""
            }
            selectable={this.props.tableSelecionavel}
            selectedItem={this.props.itemSelecionadoTable}
            onSelectItem={this.props.onSelecionarItemTable}
            onActionClick={this.onTableActionClick.bind(this)}
            actions={this.getTableActions()}
          >
            {this.props.renderColunas()}
          </Table>

          {this.props.paginavel && (
            <div>
              <Button
                label="Pág. Anterior"
                icon="fa-arrow-left"
                className="btn-primary btn-flatx mr-10"
                onClick={this.onClickPaginacao.bind(this, "ant")}
                disabled={
                  this.state.range.from <= 0 || this.state.filtroAplicado
                }
              />
              <Button
                label="Próx. Página"
                icon="fa-arrow-right"
                className="btn-primary btn-flatx"
                onClick={this.onClickPaginacao.bind(this, "prox")}
                disabled={
                  this.state.registros.length < this.state.qtderegistros ||
                  this.state.filtroAplicado
                }
              />
            </div>
          )}
        </div>

        {this.props.renderFormInicialRodape ? (
          <div className="">
            <div className="m-10">{this.props.renderFormInicialRodape()}</div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }

  /**
   * Renderiza o formulário de inclusão/alteração.
   */
  renderForm() {
    return (
      <div className="">
        <div className="m-10">{this.props.renderForm()}</div>
        <div className="m-10 pt-10 light-upper-border">
          <Button
            className="mt-5 btn-danger"
            label="Cancelar"
            onClick={() => {
              this.resetarAbas();
              this.carregarRegistros();
            }}
            icon="fa-times"
          />
          <Button
            className="mt-5 ml-5 btn-success"
            label="Confirmar"
            disabled={
              this.validaCampos()
              // ||
              //this.busca_permissao("status_incluir") == "N"
            }
            onClick={this.salvar.bind(this)}
            icon="fa-check"
          />
        </div>
      </div>
    );
  }

  renderFormEye() {
    return (
      <div className="">
        {this.props.renderFormEye ? (
          <div className="m-10">{this.props.renderFormEye()}</div>
        ) : (
          ""
        )}

        <div className="m-10 pt-10 light-upper-border">
          <Button
            className="mt-5 ml-5 btn-success"
            label="Confirmar"
            onClick={() => {
              this.resetarAbas();
              this.carregarRegistros();
            }}
            icon="fa-check"
          />
        </div>
      </div>
    );
  }

  renderFormExibicao() {
    return (
      this.props.renderFormExibicao && (
        <div className="">
          <div className="m-10">{this.props.renderFormExibicao()}</div>

          <Button
            className="mt-5 btn-green"
            label="Salvar"
            onClick={this.salvarExibicao.bind(this)}
            icon="fa-check"
          />
          <Button
            className="mt-5 ml-5 btn-danger"
            label="Cancelar"
            onClick={() => {
              this.resetarAbas();
              this.carregarRegistros();
            }}
            icon="fa-times"
          />
        </div>
      )
    );
  }

  renderFormConfiguracoes() {
    return (
      this.props.renderFormConfiguracoes && (
        <div className="">
          <div className="m-10">{this.props.renderFormConfiguracoes()}</div>

          <div className="m-10 pt-10 light-upper-border">
            <Button
              className="mt-5 btn-danger"
              label="Cancelar"
              onClick={() => {
                this.resetarAbas();
                this.carregarRegistros();
              }}
              icon="fa-times"
            />
            <Button
              className="mt-5 ml-5 btn-success btn-green"
              label="Confirmar"
              disabled={
                this.validaCampos() ||
                this.busca_permissao("status_alterar") == "N"
              }
              onClick={this.salvar.bind(this)}
              icon="fa-check"
            />
          </div>
        </div>
      )
    );
  }

  busca_permissao = (operacao) => {
    if (this.props.usuario.tipo_usuario == constants.tipo_usuario_admin) {
      return "S";
    }
    const perfil = this.props.usuario.permi.find(
      (x) => x.cod_modal == this.props.codigo_tela
    );
    if (perfil) {
      return perfil[operacao];
    }
    return "N";
  };

  renderFormRotinasCondominio() {
    return (
      this.props.renderFormRotinasCondominio && (
        <div className="">
          <div className="m-10">{this.props.renderFormRotinasCondominio()}</div>

          <div className="m-10 pt-10 light-upper-border">
            {/* <Button className="mt-5 btn-danger"
            label="Cancelar"
            onClick={() => {
              this.resetarAbas();
              this.carregarRegistros();
            }}
            icon="fa-times" />

          <Button className="mt-5 ml-5 btn-success btn-green"
            label="Confirmar"
            disabled={this.validaCampos()}
            onClick={this.salvar.bind(this)}
            icon="fa-check" /> */}
          </div>
        </div>
      )
    );
  }

  renderFormAppConectados() {
    return (
      this.props.renderFormAppConectados && (
        <div className="">
          <div className="m-10">{this.props.renderFormAppConectados()}</div>

          <div className="m-10 pt-10 light-upper-border"></div>
        </div>
      )
    );
  }

  render() {
    return (
      <div className="h-100">
        <ContentWrapper title={this.props.titulo} small={this.props.subTitulo}>
          <Tabs>
            {/* Cabeçalhos das abas: */}
            <TabsHeader>
              <TabHeader
                label="Listar"
                icon="bars"
                target="tabList"
                onClick={this.carregarRegistros.bind(this)}
              />
              {this.props.hideIncluir ? null : (
                <TabHeader
                  label="Incluir"
                  icon="plus"
                  target="tabCreate"
                  onClick={this.limparRegistros.bind(this)}
                />
              )}
              <TabHeader label="Alterar" icon="pencil" target="tabUpdate" />
              <TabHeader label="Excluir" icon="trash-o" target="tabDelete" />

              <TabHeader
                label="Configuração"
                icon="cog"
                target="tabConfig"
                onClick={this.carregarConfiguracoes.bind(this)}
              />

              <TabHeader
                label="Rotinas"
                icon="cogs"
                target="tabRotinas"
                onClick={this.carregarRotinasCondominio.bind(this)}
              />

              <TabHeader
                label="App"
                icon="mobile"
                target="tabAppConectados"
                onClick={this.carregarAppConectados.bind(this)}
              />
            </TabsHeader>

            {/* Conteúdo: */}
            <TabsContent>
              <TabContent id="tabList">
                {/* Aba de lista */}
                {this.renderList()}
              </TabContent>

              <TabContent id="tabCreate">
                {/* Aba de inclusão */}
                {this.renderForm()}
              </TabContent>

              <TabContent id="tabUpdate">
                {/* Aba de alteração */}
                {this.renderForm()}
              </TabContent>

              <TabContent id="tabEye">
                {/* Aba de alteração */}
                {this.renderFormEye()}
              </TabContent>

              <TabContent id="tabexibicao">
                {/* Aba de exibição*/}
                {this.renderFormExibicao()}
              </TabContent>

              <TabContent id="tabDelete">
                {/* Aba de exclusão: */}
                <div className="col-sm-12">{this.props.getMsgExcluir()}</div>

                <div className="m-10">
                  <Button
                    className="mt-10 btn-default"
                    label="Cancelar"
                    onClick={this.resetarAbas.bind(this)}
                    icon="fa-times"
                  />
                  <Button
                    className="mt-10 ml-5 btn-danger"
                    label="Confirmar"
                    onClick={this.excluir.bind(this)}
                    icon="fa-trash"
                  />
                </div>
              </TabContent>

              <TabContent id="tabConfig">
                {/* Aba de configração*/}
                {this.renderFormConfiguracoes()}
              </TabContent>

              <TabContent id="tabRotinas">
                {/* Aba de configração*/}
                {this.renderFormRotinasCondominio()}
              </TabContent>

              <TabContent id="tabAppConectados">
                ,{/* Aba de proprietário conectados */}
                {this.renderFormAppConectados()}
              </TabContent>
            </TabsContent>
          </Tabs>
        </ContentWrapper>
      </div>
    );
  }
}

// export default connect((state) => ({
//   funcionario: state.funcionario,
// }), (dispatch) => ({
//   dispatch,
// }), null, { withRef: true })(Cadastro);

export default connect(
  (state) => ({
    usuario: state.usuario,
    socket: state.socket,
  }),
  (dispatch) => ({
    dispatch,
  }),
  null,
  { withRef: true }
)(Cadastro);



// WEBPACK FOOTER //
// ./src/componentes/Cadastro.jsx